import { observer } from "mobx-react";
import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Form, Header, Segment, Input } from "semantic-ui-react";
import { BankAccount } from "../../../../components/project";
import { IOrgModel } from "../OrgModel";
import { AttachedFile } from "../../../../components/common";
import { ExtensionModel } from "../../../../modules/ext/ExtensionModel";
//import { OrgExt } from "../OrgExtService";

interface IDebLetter extends WithTranslation {
  org: IOrgModel;
  orgExt: any;
}

@observer
class DebLetter extends React.Component<IDebLetter> {
  //private orgExt = ExtensionModel.create();

  public async componentDidMount() {

  }

  public render() {
    const { t } = this.props;
    return (
      <Segment padded="very">
        <Header
          size="medium"
          content={t("module.admin.orgLetterInfo.title")}
          subheader={t("module.admin.orgLetterInfo.subtitle")}
          style={styles.header}
        />
        <Form>
          <Header as='h4'>{t("module.admin.orgLetterInfo.address")}</Header>
          <Segment padded>
            <Form.Group inline>
              <Form.Field width={3}>
                <label>{t("ชื่อหน่วยงาน")}</label>
              </Form.Field>
              <Form.Field width={12}>
                <Input
                  onChange={(event: any, data: any) =>
                    this.props.orgExt.setField({
                      fieldname: "letter_org_name",
                      value: data.value
                    })
                  }
                  value={this.props.orgExt.getValue("letter_org_name")}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group inline>
              <Form.Field width={3}>
                <label>{t("module.admin.orgLetterInfo.address_line1")}</label>
              </Form.Field>
              <Form.Field width={12}>
                <Input
                  onChange={(event: any, data: any) =>
                    this.props.orgExt.setField({
                      fieldname: "letter_org_address_line1",
                      value: data.value
                    })
                  }
                  value={this.props.orgExt.getValue("letter_org_address_line1")}
                  maxLength={60}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group inline>
              <Form.Field width={3}>
                <label>{t("module.admin.orgLetterInfo.address_line2")}</label>
              </Form.Field>
              <Form.Field width={12}>
                <Input
                  onChange={(event: any, data: any) =>
                    this.props.orgExt.setField({
                      fieldname: "letter_org_address_line2",
                      value: data.value
                    })
                  }
                  value={this.props.orgExt.getValue("letter_org_address_line2")}
                  maxLength={60}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group inline>
              <Form.Field width={3}>
                <label>{t("module.admin.orgLetterInfo.address_line3")}</label>
              </Form.Field>
              <Form.Field width={12}>
                <Input
                  onChange={(event: any, data: any) =>
                    this.props.orgExt.setField({
                      fieldname: "letter_org_address_line3",
                      value: data.value
                    })
                  }
                  value={this.props.orgExt.getValue("letter_org_address_line3")}
                  maxLength={60}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group inline>
              <Form.Field width={3}>
                <label>{t("module.admin.orgLetterInfo.address_line4")}</label>
              </Form.Field>
              <Form.Field width={12}>
                <Input
                  onChange={(event: any, data: any) =>
                    this.props.orgExt.setField({
                      fieldname: "letter_org_address_line4",
                      value: data.value
                    })
                  }
                  value={this.props.orgExt.getValue("letter_org_address_line4")}
                  maxLength={60}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group inline>
              <Form.Field width={3}>
                <label>{t("module.admin.orgLetterInfo.address_line5")}</label>
              </Form.Field>
              <Form.Field width={12}>
                <Input
                  onChange={(event: any, data: any) =>
                    this.props.orgExt.setField({
                      fieldname: "letter_org_address_line5",
                      value: data.value
                    })
                  }
                  value={this.props.orgExt.getValue("letter_org_address_line5")}
                  maxLength={60}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group inline>
              <Form.Field width={3}>
                <label>{t("module.admin.orgLetterInfo.address_line6")}</label>
              </Form.Field>
              <Form.Field width={12}>
                <Input
                  onChange={(event: any, data: any) =>
                    this.props.orgExt.setField({
                      fieldname: "letter_org_address_line6",
                      value: data.value
                    })
                  }
                  value={this.props.orgExt.getValue("letter_org_address_line6")}
                  maxLength={60}
                />
              </Form.Field>
            </Form.Group>
          </Segment>
          <Header as='h4'>{t("module.admin.orgLetterInfo.endorser")}</Header>
          <Segment padded>
            <Form.Group inline>
              <Form.Field width={3}>
                <label>{t("module.admin.orgLetterInfo.endorser_name")}</label>
              </Form.Field>
              <Form.Field width={12}>
                <Input
                  onChange={(event: any, data: any) =>
                    this.props.orgExt.setField({
                      fieldname: "endorser_name",
                      value: data.value
                    })
                  }
                  value={this.props.orgExt.getValue("endorser_name")}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group inline>
              <Form.Field width={3}>
                <label>{t("module.admin.orgLetterInfo.endorser_position_line1")}</label>
              </Form.Field>
              <Form.Field width={12}>
                <Input
                  onChange={(event: any, data: any) =>
                    this.props.orgExt.setField({
                      fieldname: "endorser_position_line1",
                      value: data.value
                    })
                  }
                  value={this.props.orgExt.getValue("endorser_position_line1")}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group inline>
              <Form.Field width={3}>
                <label>{t("module.admin.orgLetterInfo.endorser_position_line2")}</label>
              </Form.Field>
              <Form.Field width={12}>
                <Input
                  onChange={(event: any, data: any) =>
                    this.props.orgExt.setField({
                      fieldname: "endorser_position_line2",
                      value: data.value
                    })
                  }
                  value={this.props.orgExt.getValue("endorser_position_line2")}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group inline>
              <Form.Field width={3}>
                <label>{t("module.admin.orgLetterInfo.endorser_position_line3")}</label>
              </Form.Field>
              <Form.Field width={12}>
                <Input
                  onChange={(event: any, data: any) =>
                    this.props.orgExt.setField({
                      fieldname: "endorser_position_line3",
                      value: data.value
                    })
                  }
                  value={this.props.orgExt.getValue("endorser_position_line3")}
                />
              </Form.Field>
            </Form.Group>
          </Segment>
          <Header as='h4'>{t("module.admin.orgLetterInfo.letter_footer")}</Header>
          <Segment padded>
            <Form.Group inline>
              <Form.Field width={3}>
                <label>{t("module.admin.orgLetterInfo.letter_footer_line1")}</label>
              </Form.Field>
              <Form.Field width={12}>
                <Input
                  onChange={(event: any, data: any) =>
                    this.props.orgExt.setField({
                      fieldname: "letter_footer_line1",
                      value: data.value
                    })
                  }
                  value={this.props.orgExt.getValue("letter_footer_line1")}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group inline>
              <Form.Field width={3}>
                <label>{t("module.admin.orgLetterInfo.letter_footer_line2")}</label>
              </Form.Field>
              <Form.Field width={12}>
                <Input
                  onChange={(event: any, data: any) =>
                    this.props.orgExt.setField({
                      fieldname: "letter_footer_line2",
                      value: data.value
                    })
                  }
                  value={this.props.orgExt.getValue("letter_footer_line2")}
                />
              </Form.Field>
            </Form.Group>
          </Segment>
          <Header as='h4'>{t("module.admin.orgLetterInfo.digital_sign")}</Header>
          <Segment padded>
            <Form.Group widths="equal">
              <Form.Field
                label={t("")}
                mode="edit"
                control={AttachedFile}
                multiple={false}
                addFile={(f: File) => this.props.orgExt.setFile(f, "file_letter_signature")}
                removeFile={(index?: number) => this.onRemoveFile(index!)}
                fieldName="file_letter_signature"
                files={this.props.orgExt.getFile("file_letter_signature")}

              />
            </Form.Group>
            <Form.Checkbox
              label={t("module.admin.orgLetterInfo.digital_sign_used")}
              onChange={(event: any, data: any) =>
                this.props.orgExt.setField({
                  fieldname: "digital_sign_used",
                  value: data.checked ? "1" : "0"
                })
              }
              checked={this.props.orgExt.getValue("digital_sign_used") === "1"}
            />
          </Segment>
          <Header as='h4'>{t("module.admin.orgLetterInfo.letter_info")}</Header>
          <Segment padded>
            <Form.Group inline>
              <Form.Field width={3}>
                <label>{t("module.admin.orgLetterInfo.licence_no")}</label>
              </Form.Field>
              <Form.Field width={12}>
                <Input
                  onChange={(event: any, data: any) =>
                    this.props.orgExt.setField({
                      fieldname: "licence_no",
                      value: data.value
                    })
                  }
                  value={this.props.orgExt.getValue("licence_no")}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group inline>
              <Form.Field width={3}>
                <label>{t("module.admin.orgLetterInfo.postoffice_name")}</label>
              </Form.Field>
              <Form.Field width={12}>
                <Input
                  onChange={(event: any, data: any) =>
                    this.props.orgExt.setField({
                      fieldname: "postoffice_name",
                      value: data.value
                    })
                  }
                  value={this.props.orgExt.getValue("postoffice_name")}
                />
              </Form.Field>
            </Form.Group>
            <Header as='h4'>{t("module.admin.orgLetterInfo.letter_info")}</Header>
            <Form.Group inline>
              <Form.Field width={3}>
                <label>{t("ชื่อหน่วยงานหน้าซองจดหมาย")}</label>
              </Form.Field>
              <Form.Field width={12}>
                <Input
                  onChange={(event: any, data: any) =>
                    this.props.orgExt.setField({
                      fieldname: "letter_address_org",
                      value: data.value
                    })
                  }
                  value={this.props.orgExt.getValue("letter_address_org")}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group inline>
              <Form.Field width={3}>
                <label>{t("module.admin.orgLetterInfo.letter_address_line1")}</label>
              </Form.Field>
              <Form.Field width={12}>
                <Input
                  onChange={(event: any, data: any) =>
                    this.props.orgExt.setField({
                      fieldname: "letter_address_line1",
                      value: data.value
                    })
                  }
                  value={this.props.orgExt.getValue("letter_address_line1")}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group inline>
              <Form.Field width={3}>
                <label>{t("module.admin.orgLetterInfo.letter_address_line2")}</label>
              </Form.Field>
              <Form.Field width={12}>
                <Input
                  onChange={(event: any, data: any) =>
                    this.props.orgExt.setField({
                      fieldname: "letter_address_line2",
                      value: data.value
                    })
                  }
                  value={this.props.orgExt.getValue("letter_address_line2")}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group inline>
              <Form.Field width={3}>
                <label>{t("module.admin.orgLetterInfo.letter_address_line3")}</label>
              </Form.Field>
              <Form.Field width={12}>
                <Input
                  onChange={(event: any, data: any) =>
                    this.props.orgExt.setField({
                      fieldname: "letter_address_line3",
                      value: data.value
                    })
                  }
                  value={this.props.orgExt.getValue("letter_address_line3")}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group inline>
              <Form.Field width={3}>
                <label>{t("module.admin.orgLetterInfo.letter_address_line4")}</label>
              </Form.Field>
              <Form.Field width={12}>
                <Input
                  onChange={(event: any, data: any) =>
                    this.props.orgExt.setField({
                      fieldname: "letter_address_line4",
                      value: data.value
                    })
                  }
                  value={this.props.orgExt.getValue("letter_address_line4")}
                />
              </Form.Field>
            </Form.Group>
          </Segment>
          <Form.Group widths="equal">
            <Form.Field />
            <Form.Button
              width={5}
              id="form-button-submit-deb-letter-form"
              fluid
              floated="right"
              color="blue"
              onClick={this.onClickSave}
            >
              {t("module.admin.authorizedPersonForm.save")}
            </Form.Button>
          </Form.Group>
        </Form>
      </Segment>
    );
  }

  public updateData = () => {

  }

  public onClickSave = async () => {
    const { t, org } = this.props;
    //console.log(org);
    //console.log(this.props.orgExt.getValue("letter_address_line4"));
    try {
      org.setField({ fieldname: "loading", value: true });
      await this.props.orgExt.updateOrgExt();
      org.error.setField({ fieldname: "tigger", value: false });
      org.alert.setAlertMessage(
        "บันทึกสำเร็จค่ะ",
        "ข้อมูลหน่วยงานถูกปรับปรุงเรียบร้อยแล้ว"
      );

    } catch (e) {
      throw e;
    } finally {
      org.setField({ fieldname: "loading", value: false });
    }

  }

  private onRemoveFile = async (index: number) => {
    const { orgExt } = this.props;
    try {
      await orgExt.removeFile(index);
    } catch (e) {
      console.log(e);
    }
  };

  private updateForm = async () => {
    const { org } = this.props;

    try {
      await org.updateBankOrg();
    } catch (e) {
      throw e;
    }
  };


}

const styles: any = {
  header: {
    marginBottom: 28
  },
  row: {
    paddingTop: 0,
    paddingBottom: 0
  },
  column: {
    paddingTop: 14,
    paddingBottom: 14
  }
};

export default withTranslation()(DebLetter);
